import { sdk } from "@lib/config"

export type ChassisListItem = {
  productHandle: string
  label: string
  formFactor: "1U" | "2U"
  sffBays: number
  lffBays: number
  dimmSlots: number
  pcieSlots: number
  hasFlexLom: boolean
  maxTdpPerSocket: number
  productId: string | null
  title: string
  description: string | null
  thumbnail: string | null
  basePrice: number | null
  currencyCode: string | null
}

export type ComponentItem = {
  handle: string
  productId: string
  title: string
  description: string | null
  thumbnail: string | null
  sku: string | null
  price: number | null
  currencyCode: string | null
}

export type ChassisDetail = ChassisListItem & {
  components: Partial<Record<string, ComponentItem[]>>
}

export type ValidationResponse = {
  valid: boolean
  errors?: string[]
  warnings: string[]
  pricing: {
    currencyCode: string
    total: number
    lineItems: Array<{
      handle: string
      title: string
      sku: string | null
      quantity: number
      unitPrice: number
      subtotal: number
    }>
  }
}

export async function listChassis(): Promise<ChassisListItem[]> {
  const res = await sdk.client.fetch<{ chassis: ChassisListItem[] }>(
    "/store/configurator/chassis",
  )
  return res.chassis
}

export async function getChassisDetail(handle: string): Promise<ChassisDetail> {
  const res = await sdk.client.fetch<{
    chassis: ChassisListItem
    components: Record<string, ComponentItem[]>
  }>(`/store/configurator/chassis/${handle}`)
  return { ...res.chassis, components: res.components }
}

export async function validateConfig(input: {
  chassis: string
  components: Array<{ handle: string; quantity: number }>
}): Promise<ValidationResponse> {
  return await sdk.client.fetch<ValidationResponse>(
    "/store/configurator/validate",
    { method: "POST", body: input },
  )
}

export async function addConfigToCart(input: {
  cart_id: string
  chassis: string
  components: Array<{ handle: string; quantity: number }>
}): Promise<{ build_id: string; warnings: string[]; cart: unknown }> {
  return await sdk.client.fetch<{ build_id: string; warnings: string[]; cart: unknown }>(
    "/store/configurator/add-to-cart",
    { method: "POST", body: input },
  )
}
